import React from 'react';

const APP_NAME = 'Water Temp';

const WaterTempPrivacy = () => {
  return (
    <div className="min-h-screen bg-white text-gray-800 px-6 py-16">
      <h1 className="text-4xl font-bold mb-6 text-center">Privacy Policy</h1>
      <p className="text-center text-gray-600 mb-4">Last Updated: August 2026</p>
      <hr className="my-6" />

      <div className="max-w-3xl mx-auto space-y-6 text-justify leading-relaxed">
        <p>
          {APP_NAME} ("the App") is developed by N1İnovasyon ("we", "us", or "our"). We take your privacy
          seriously. This Privacy Policy explains what information the App handles, how it is used, and how
          it is protected. The App is an Apple Watch application that measures water temperature using the
          built-in water temperature sensor of supported Apple Watch models.
        </p>

        <h2 className="text-xl font-semibold mt-8">1. Information We Collect</h2>
        <p>
          The App is designed to work without collecting personal data. We do not require you to create an
          account, and we do not ask for your name, email address, phone number, contacts, photos, or precise
          location. The App does not contain advertising or third-party tracking SDKs, and we do not sell,
          rent, or share your data with third parties.
        </p>

        <h2 className="text-xl font-semibold mt-8">2. Water Temperature and Sensor Data</h2>
        <p>
          The App reads water temperature measurements from the built-in sensor of your Apple Watch using
          Apple's system frameworks. Supported models include Apple Watch Ultra, Ultra 2, Ultra 3,
          Series 10, and Series 11.
        </p>
        <ul className="list-disc ml-6 space-y-1">
          <li>Sensor readings are processed and stored locally on your Apple Watch and paired iPhone.</li>
          <li>Readings are never transmitted to our servers and are never used for advertising or profiling.</li>
          <li>
            If the App reads from or writes to Apple Health (HealthKit), it does so only with your explicit
            permission, and this data is used solely to provide the App's features. Health data is never
            shared with third parties, sold, or used for marketing, in accordance with Apple's HealthKit
            guidelines. You can revoke this permission at any time in the Health app.
          </li>
        </ul>

        <h2 className="text-xl font-semibold mt-8">3. In-App Purchases</h2>
        <p>
          The App offers a one-time lifetime purchase (currently $2.99, or the equivalent in your local
          currency) that unlocks the full version. All payments are processed by Apple through the App Store.
          We do not receive or store your payment card details, billing address, or Apple ID credentials.
          Apple's own privacy policy governs the payment process. We may receive anonymous transaction
          information (such as whether a purchase was completed) solely to unlock the purchased features on
          your device.
        </p>

        <h2 className="text-xl font-semibold mt-8">4. Data Storage and Security</h2>
        <p>
          All App data is stored on your device. If you have iCloud backup enabled, your device backups
          (which may include App data) are handled by Apple under Apple's privacy terms. We do not operate
          servers that store your measurements.
        </p>

        <h2 className="text-xl font-semibold mt-8">5. Diagnostic Information</h2>
        <p>
          If you have opted in to share analytics with app developers in your iOS settings, Apple may provide
          us with anonymous, aggregated crash and usage diagnostics. This information does not identify you
          and is used only to improve the App's stability.
        </p>

        <h2 className="text-xl font-semibold mt-8">6. Children's Privacy</h2>
        <p>
          The App is not directed to children under 13, and we do not knowingly collect any data from
          children under 13. If you believe such data has been collected, please contact us and we will
          delete it promptly.
        </p>

        <h2 className="text-xl font-semibold mt-8">7. Your Rights</h2>
        <p>
          Because your data stays on your device, you have full control over it. You can delete all App data
          at any time by removing the App from your Apple Watch and iPhone. If you have any questions about
          your data or wish to exercise your rights under applicable privacy laws (such as the GDPR or
          CCPA), please contact us using the details below.
        </p>

        <h2 className="text-xl font-semibold mt-8">8. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. The latest version will always be available
          on our website and within the App. Continued use of the App after changes means you accept the
          updated policy.
        </p>

        <h2 className="text-xl font-semibold mt-8">9. Contact</h2>
        <p>
          If you have any questions, suggestions, or requests regarding this Privacy Policy, please contact us:
        </p>
        <p className="ml-4">
          Email: <a href="mailto:hi@n1inovasyon.com" className="text-blue-600">hi@n1inovasyon.com</a>
        </p>

        <p className="text-sm text-gray-500 mt-8">
          Apple, Apple Watch, Apple Watch Ultra, and HealthKit are trademarks of Apple Inc. {APP_NAME} is an
          independent product and is not affiliated with or endorsed by Apple Inc.
        </p>
      </div>
    </div>
  );
};

export default WaterTempPrivacy;
